export const IMPACT_CALCULATION_TITLE = 'Como calculamos seu impacto?';
export const IMPACT_CERTIFICATE_BACKGROUND_SRC = '/img/certificate-background.jpg';
export const IMPACT_CERTIFICATE_NAME_MAX_LENGTH = 50;
